import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { useTagGroupStyles_unstable } from '@fluentui/react-tags';
import { tokens } from '@fluentui/react-theme';
import { tagSizeToTagPickerSize } from '../../utils/tagPicker2Tag';
export const tagPickerGroupClassNames = {
  root: 'fui-TagPickerGroup'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    Eh141a: "fni485r",
    B7ck84d: "f1ewtqcl",
    Bceei9c: "f113hnb5"
  },
  medium: {
    z8tnut: "fp2oml8",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1tdddsa",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    i8kkvl: "f1ufnopg",
    Belr9w4: "f14sijuj"
  },
  large: {
    z8tnut: "f1kwiid1",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f5b47ha",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    i8kkvl: "f1rjii52",
    Belr9w4: "f1r7g2jn"
  },
  "extra-large": {
    z8tnut: "f1kwiid1",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f5b47ha",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    i8kkvl: "f1rjii52",
    Belr9w4: "f1r7g2jn"
  }
}, {
  d: [".fni485r{flex-wrap:wrap;}", ".f1ewtqcl{box-sizing:border-box;}", ".f113hnb5{cursor:text;}", ".fp2oml8{padding-top:var(--spacingVerticalSNudge);}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1tdddsa{padding-bottom:var(--spacingVerticalSNudge);}", ".f1ufnopg{column-gap:var(--spacingHorizontalXS);}", ".f14sijuj{row-gap:var(--spacingHorizontalXS);}", ".f1kwiid1{padding-top:var(--spacingVerticalS);}", ".f5b47ha{padding-bottom:var(--spacingVerticalS);}", ".f1rjii52{column-gap:var(--spacingHorizontalSNudge);}", ".f1r7g2jn{row-gap:var(--spacingHorizontalSNudge);}"]
});
/**
 * Apply styling to the TagPickerGroup slots based on the state
 */
export const useTagPickerGroupStyles_unstable = state => {
  useTagGroupStyles_unstable(state);
  const styles = useStyles();
  state.root.className = mergeClasses(tagPickerGroupClassNames.root, styles[tagSizeToTagPickerSize(state.size)], styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useTagPickerGroupStyles.styles.js.map